import { createFileRoute } from '@tanstack/react-router';
import {
  loadUserMessages,
  loadUserScreens,
  userDetailScreen,
  userDetailSearch,
} from '@/modules/user/route';
import { lazyScreen } from '@/shared/screen';
export const Route = createFileRoute('/_app/seguranca/usuarios/$userId/')({
  validateSearch: userDetailSearch,
  staticData: { screen: userDetailScreen },
  loader: () => loadUserMessages(),
  component: lazyScreen(loadUserScreens, 'UserFormPage'),
});
